import { Box, Typography } from '@mui/material'
import { ContainerDamageResponseDto } from '@planning/app/api'
import { useTranslate } from '@tolgee/react'
import { DamagedIcon, useMinimalsTheme } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'

export type OrderDamagesButtonProps = {
  activeDamages: ContainerDamageResponseDto[]
  onClick?: () => void
}

export const OrderDamagesButton: FC<OrderDamagesButtonProps> = observer(props => {
  const { activeDamages, onClick } = props
  const { t } = useTranslate()
  const theme = useMinimalsTheme()

  const damagesCount = activeDamages?.length || 0

  const chipColor = () => (damagesCount ? theme.palette.warning.dark : theme.palette.grey[600])
  const chipBgColor = () => (damagesCount ? theme.palette.warning.lighter : theme.palette.grey[200])

  return (
    <Box
      onClick={onClick}
      sx={{
        cursor: 'pointer',
        background: chipBgColor(),
        padding: '4px 8px',
        borderRadius: '4px',
        display: 'flex',
        height: '32px',
      }}
    >
      <Typography
        display={'flex'}
        fontSize={'14px'}
        alignSelf={'center'}
        alignItems={'center'}
        fontWeight={500}
        color={chipColor()}
        gap={1}
        p={0.4}
      >
        <DamagedIcon />
        {t('xDamages', '{count} damages', {
          count: damagesCount,
        })}
      </Typography>
    </Box>
  )
})
